import React from 'react'
import { Column } from '@components/Common'
import { TabPanel } from '@components/Tabs/index'
import News from '@components/PracticeDetail/components/News'
import Insights from '@components/PracticeDetail/components/Insights'
import Professional from '@components/PracticeDetail/components/Professionals'
import { generateRandomKey } from '@utils'
import Overview from '@components/PracticeDetail/components/Overview'

const CurrentTabPanel = ({
  practiceArray,
  tab,
  setTab,
  content,
  descriptionHtml,
  insights,
  news,
  professionals,
  preview,
  practiceChairs,
  relatedPracticeAreas,
  callouts,
}) => {
  const tabsArr = ['overview', 'insights', 'professionals', 'news & events']
  return (
    <Column>
      {practiceArray &&
        tabsArr.map((t, index) => {
          if (t !== null && t !== undefined) {
            if (index === 0) {
              return (
                <TabPanel
                  index={0}
                  key={generateRandomKey()}
                  tab={tab}
                  setTab={setTab}
                  label="overview-content"
                >
                  <Overview
                    content={content}
                    descriptionHtml={descriptionHtml}
                    practiceChairs={practiceChairs}
                    relatedPracticeAreas={relatedPracticeAreas}
                    callouts={callouts}
                  />
                </TabPanel>
              )
            }
            if (index === 1 && insights?.length) {
              return (
                <TabPanel
                  index={1}
                  tab={tab}
                  setTab={setTab}
                  key={generateRandomKey()}
                  label="insights-content"
                >
                  <Insights tabContent={insights} />
                </TabPanel>
              )
            }
            if (index === 3 && news?.length) {
              return (
                <TabPanel
                  index={3}
                  tab={tab}
                  setTab={setTab}
                  key={generateRandomKey()}
                  label="news-content"
                >
                  <News tabContent={news} />
                </TabPanel>
              )
            }
            if (index === 2 && professionals?.length) {
              return (
                <TabPanel
                  index={2}
                  key={generateRandomKey()}
                  tab={tab}
                  setTab={setTab}
                >
                  <Professional
                    tabContent={professionals}
                    label="professional-tab"
                    preview={preview}
                  />
                </TabPanel>
              )
            }
          }
        })}
    </Column>
  )
}

CurrentTabPanel.propTypes = {}

export default CurrentTabPanel
